export default [
  {
    path: '/zjd/preAuthQuery', // 预授权进度查询
    name: 'preAuthQuery',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/index.vue'
      )
    }
  },
  {
    path: '/zjd/preAuthDetail', // 预授权报案详情
    name: 'preAuthDetail',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preAuthDetail.vue'
      )
    }
  },
  {
    path: '/zjd/preDetail', // 预授权报案详情
    name: 'preDetail',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preDetail.vue'
      )
    }
  },
  {
    path: '/zjd/preAuth', // 预授权操作列表
    name: 'preAuth',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preAuth.vue'
      )
    }
  },
  {
    path: '/zjd/preauthapply', // 预授权申请
    name: 'preauthapply',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preAuthApply.vue'
      )
    }
  },
  {
    path: '/zjd/suppleDetail', // 预授权详情
    name: 'suppleDetail',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/suppleDetail.vue'
      )
    }
  },
  {
    path: '/zjd/suppleMaterialList', // 预授权补充材料列表
    name: 'suppleMaterialList',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/suppleMaterialList.vue'
      )
    }
  },
  {
    path: '/zjd/preAuthMaterial', // 预授权材料补充
    name: 'preAuthMaterial',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preAuthMaterial.vue'
      )
    }
  },
  {
    path: '/zjd/preAuthGuide', // 预授权服务指南
    name: 'preAuthGuide',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preAuthGuide.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/preAuthProve', // 预授权单证下载
    name: 'preAuthProve',
    component: () => {
      return import(
        /* webpackChunkName: "preauthorize" */ '@/views/preauthorize/preAuthProve.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  }
]
